export default __webpack_public_path__ + "static/media/08_DAIF_WHY_DELL_02_loop.29b8048b.mp4";